/**
 * ===============================
 * AUTH STORE (PRODUCTION READY)
 * ===============================
 */

const TOKEN_KEY = "auth_token";
const USER_KEY = "auth_user";

function safeGet(key) {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

function safeSet(key, value) {
  try {
    localStorage.setItem(key, value);
  } catch {
    // ignore (private mode / quota)
  }
}

function safeRemove(key) {
  try {
    localStorage.removeItem(key);
  } catch {
    // ignore
  }
}

export const AuthStore = {
  /* ==========================
   * TOKEN
   * ========================== */

  getToken() {
    return safeGet(TOKEN_KEY);
  },

  setToken(token) {
    if (!token) return;
    safeSet(TOKEN_KEY, token);
  },

  /* ==========================
   * USER (OPTIONAL)
   * ========================== */

  getUser() {
    const raw = safeGet(USER_KEY);
    if (!raw) return null;

    try {
      return JSON.parse(raw);
    } catch {
      return null;
    }
  },

  setUser(user) {
    if (!user) return;
    safeSet(USER_KEY, JSON.stringify(user));
  },

  /* ==========================
   * AUTH STATE
   * ========================== */

  isLoggedIn() {
    return Boolean(this.getToken());
  },

  /* ==========================
   * LOGOUT
   * ========================== */

  logout({ redirect = true } = {}) {
    safeRemove(TOKEN_KEY);
    safeRemove(USER_KEY);

    // sync logout across tabs
    try {
      localStorage.setItem("auth_logout", Date.now().toString());
    } catch {}

    if (redirect) {
      window.location.replace("/admin");
    }
  },
};

/**
 * ===============================
 * MULTI-TAB LOGOUT SYNC
 * ===============================
 */
window.addEventListener("storage", (event) => {
  if (event.key === "auth_logout") {
    window.location.replace("/admin");
  }
});
